import JSZip, { file } from "jszip";
import { saveAs } from "file-saver";
import { FILE_TYPE_TO_PDF } from "../../config/general_vars";

export async function downloadFilesAsArray(files){
  const file_array = [];
  console.log(files,"files");
  
  try {
    await Promise.all(files.map(async (file, index) => {
      try {
        const fileUrl = file["@microsoft.graph.downloadUrl"];
        const response = await fetch(fileUrl);
        
        if (!response.ok) {
          throw new Error(`Failed to download file ${file.name}: ${response.status} ${response.statusText}`);
        }
        
        const arrayBuffer = await response.arrayBuffer();
        const contentBytes = Buffer.from(arrayBuffer).toString("base64");
        
        const file_name = file.name;
        const file_type = getFileExtension(file_name);
        const contentType = file.file.mimeType;
        
        file_array[index] = {
          file_name,
          file_type,
          file_content: contentBytes,
          name: file_name,
          contentBytes: contentBytes,
          contentType: contentType,
          size: arrayBuffer.byteLength
        };
      } catch (error) {
        console.error(`Error downloading file ${file.name}:`, error);
        // Skip this file but continue with others
      }
    }));
  } catch (error) {
    console.error("Error in downloadFilesAsArray:", error);
  }
  
  console.log(file_array,"file_array");
  return file_array.filter(Boolean); // Remove any undefined entries from failed downloads
}
/**
 * Download the provided list of files as a zip file.
 *
 * @param {Array} files - An array of file objects where each object should have at least:
 *    - downloadUrl: The URL from where to download the file.
 *    - name: The name of the file.
 * @param {String} zipName - The name of the resulting zip file (without .zip).
 */
export async function downloadFilesAsZip(files, zipName = "downloaded_files") {
  console.log(files);
  if (files.length > 1) {
    const zip = new JSZip();

    // Loop through the file array and add each file to the zip
    for (let i = 0; i < files.length; i++) {
      const fileUrl = files[i]["@microsoft.graph.downloadUrl"];
      const fileName = files[i].name || `file${i}.txt`; // Custom or default name

      try {
        // Fetch the file as a blob
        const response = await fetch(fileUrl);
        const blob = await response.blob();

        // Add the blob to the zip archive
        zip.file(fileName, blob);
      } catch (error) {
        console.error(`Error downloading file ${fileName}:`, error);
      }
    }

    // Generate the zip file and trigger the download
    zip.generateAsync({ type: "blob" }).then((zipBlob) => {
      // Use FileSaver to save the zip file with the provided zip name
      saveAs(zipBlob, `${zipName}.zip`);
    });
  } else {
    window.open(files[0]["@microsoft.graph.downloadUrl"]);
  }
}


/**
 * Download the provided list of files as a zip file.
 *
 * @param {Array} files - An array of file objects where each object should have at least:
 *    - downloadUrl: The URL from where to download the file.
 *    - name: The name of the file.
 * @param {String} zipName - The name of the resulting zip file (without .zip).
 */
export async function attachmentsAsZip(files, zipName = "downloaded_files") {
  console.log(files);

  if (files.length > 1) {
    const zip = new JSZip();

    // Loop through the file array and add each file to the zip
    for (let i = 0; i < files.length; i++) {
      const fileName = files[i].name;

      try {
        const attachment = files[i];
        // Decode Base64 using more efficient method
        const byteCharacters = atob(attachment.contentBytes);
        const byteNumbers = Uint8Array.from(byteCharacters, char => char.charCodeAt(0));

        // Create Blob
        const blob = new Blob([byteNumbers], { type: attachment.contentType });

        // Add the blob to the zip archive
        zip.file(fileName, blob);
      } catch (error) {
        console.error(`Error downloading file ${fileName}:`, error);
      }
    }

    // Generate the zip file and trigger the download
    zip.generateAsync({ type: "blob" }).then((zipBlob) => {
      // Use FileSaver to save the zip file with the provided zip name
      saveAs(zipBlob, `${zipName}.zip`);
    });
  } else {
    let attachment = files[0];
    // Decode Base64 using more efficient method
    const byteCharacters = atob(attachment.contentBytes);
    const byteNumbers = Uint8Array.from(byteCharacters, char => char.charCodeAt(0));

    // Create Blob
    const blob = new Blob([byteNumbers], { type: attachment.contentType });

    // Create a download link
    const link = document.createElement("a");
    const blobUrl = URL.createObjectURL(blob);
    link.href = blobUrl;
    link.download = attachment.name || "downloaded_file";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Clean up blob URL to prevent memory leaks
    URL.revokeObjectURL(blobUrl);
  }
}

export const returnFileTypeImage = (file_name) => {
 let extension = getFileExtension(file_name);
  var return_val = require("@/assets/img/email/attachment-images/doc.svg");
  switch (extension) {
    case "docx":
      return_val = require("@/assets/img/email/attachment-images/doc.svg");
      break;
    case "doc":
      return_val = require("@/assets/img/email/attachment-images/doc.svg");
      break;
    case "pdf":
      return_val = require("@/assets/img/email/attachment-images/PDF.svg");
      break;
    case "csv":
      return_val = require("@/assets/img/email/attachment-images/xls.svg");
      break;
    case "xls":
      return_val = require("@/assets/img/email/attachment-images/xls.svg");
      break;
    case "xlsx":
      return_val = require("@/assets/img/email/attachment-images/xls.svg");
      break;

    case "ppt":
      return_val = require("@/assets/img/email/attachment-images/ppt.svg");
      break;
    case "pptx":
      return_val = require("@/assets/img/email/attachment-images/ppt.svg");
      break;

    case "zip":
      return_val = require("@/assets/img/email/attachment-images/zip.svg");
      break;
    case "txt":
      return_val = require("@/assets/img/email/attachment-images/txt.svg");
      break;

    case "png":
      return_val = require("@/assets/img/email/attachment-images/png.svg");
      break;
    case "jpg":
      return_val = require("@/assets/img/email/attachment-images/jpg.svg");
      break;
    case "jpeg":
      return_val = require("@/assets/img/email/attachment-images/jpg.svg");
      break;

    default:
      return_val = require("@/assets/img/email/attachment-images/doc.svg");
      break;
  }
  return return_val;
};


export const canConvertFileToPDF = (file_name) => {
  const extension = getFileExtension(file_name);
  return (FILE_TYPE_TO_PDF.findIndex(p=> p.endsWith(extension)) >= 0);
}

export const getFileExtension = (filename) =>{
  if (!filename || typeof filename !== 'string') {
      return null;
  }
  
  const parts = filename.split('.');
  
  return parts.length > 1 ? parts.pop().toLowerCase() : null;
}



export const getFileNameNoExt = (filename) =>{
  if (!filename || typeof filename !== 'string') {
      return null;
  }
  
  const parts = filename.split('.');
  
  if(parts.length>1)
  {
    parts.pop();
   return parts.join(".")
  }else{
    return filename;
  }
}



export const getShortFileName = (filename)=>{
  const extension = getFileExtension(filename);
  console.log(extension,"extension");
  console.log(getFileNameNoExt(filename).slice(0,12), extension,"filename");
  const clear = filename.length > 15 ? getFileNameNoExt(filename).slice(0,9).concat("."+extension): filename
  return clear;
}